import axios from "axios";
import { inject, injectable } from "inversify";
import { IStorageFolderRepository } from "@domain/repositories";
import type { PathTypeSchema } from "@domain/schemas/BI";
import { API_ENDPOINTS } from "@infrastructure/InfrastructureConstants";
import { runtimeConfig } from "@utils/runtimeConfig/runtimeConfig";
import { TYPES } from "@utils/inversifyJS/types";
import type { IAuthenticatedRequestHandlerService } from "@application/contracts/services";

@injectable()
export class StorageFolderRepository implements IStorageFolderRepository {
  @inject(TYPES.IAuthenticatedRequestHandlerService)
  private _requestHandlerService!: IAuthenticatedRequestHandlerService;

  public async listFoldersAsync(pathType: PathTypeSchema, folder: string): Promise<string[]> {
    const params = new URLSearchParams({ pathType: String(pathType), folder });
    const url = `${runtimeConfig.API_BASE_URL}${API_ENDPOINTS.storageConfigurationFolders}?${params.toString()}`;
    return this._requestHandlerService.handleRequestAsync<string[]>(() => axios.get<string[]>(url));
  }
}
